import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity } from 'react-native';
import Svg, { Path } from '@dbk/ui-svg';
import { Sort } from '@dbk/ui-icons';
import Text, { Small } from '../text';
import styles from './sorting-header.styles';
import { PALETTE, QUANTITY, STüCKZAHL } from '../../../constants';

const noOp = () => { };

const arrowDescending =
  'M5.245 4.748L8.773.828C9.185.372 9.02 0 8.406 0H.592C-.022 ' +
  '0-.183.375.226.83l3.527 3.918c.412.458 1.083.455 1.492 0z';

const arrowAscending =
  'M8.773 4.26c.412.46.248.83-.367.83H.592c-.614 ' +
  '0-.775-.374-.366-.83L3.753.343c.412-.458 1.083-.454 1.492 0l3.528 3.92z';

export default class SortingHeader extends PureComponent {
  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        key: PropTypes.string,
        width: PropTypes.number,
        displayCurrency: PropTypes.bool,
        isPhone: PropTypes.bool,
        isTablet: PropTypes.bool,
        optionStyle: PropTypes.obj,
      })
    ),
    state: PropTypes.shape({
      selectedKey: PropTypes.string,
      ascending: PropTypes.bool,
      onOptionSelect: PropTypes.func,
    }),
    enabled: PropTypes.bool,
    currency: PropTypes.string,
    screen: PropTypes.shape({
      isSmall: PropTypes.bool,
    }),
    isPosTransFactory: PropTypes.bool
  };

  static defaultProps = {
    options: [],
    state: {
      selectedKey: '',
      ascending: false,
      onOptionSelect: noOp,
    },
    enabled: false,
    showBorder: false,
    screen: {
      isSmall: false,
    },
  };

  constructor(props, context) {
    super(props, context);
    this.renderOption = this.renderOption.bind(this);
    this.state = {
      noOfClicks: 0,
      optionKey: null
    }
  }

  componentDidMount() {
    const { state = {} } = this.props;
  }

  onOptionPress(key, ascending) {
    const { state = {} } = this.props;
    const { onOptionSelect } = state;
    if (onOptionSelect) {
      onOptionSelect({ key, ascending });
    }
  }

  renderSortAsset(isSelected) {
    const { state = {} } = this.props;
    const { ascending } = state;
    let upArrowColor = PALETTE.loginFooterText;
    let downArrowColor = PALETTE.loginFooterText;
    if (ascending === false) {
      upArrowColor = PALETTE.loginFooterText;
      downArrowColor = PALETTE.primaryActive;
    } else if (ascending === true) {
      upArrowColor = PALETTE.primaryActive;
      downArrowColor = PALETTE.loginFooterText;
    }
    const sortArrowTestId = ascending === true ? 'sort-arrow-ascending' :
      ascending === false ? 'sort-arrow-descending'
        : 'sort-arrow-default';
    if (isSelected) {
      return (
        <View style={styles.sortArrow} testID={sortArrowTestId}>
          <Sort className="assetSorting_icon" width={20} height={20} color={PALETTE.primaryText} upArrowColor={upArrowColor} downArrowColor={downArrowColor} />
        </View>
      );
    } else {
      return (
        <View style={styles.sortArrow} testID={sortArrowTestId}>
          <Sort className="assetSorting_icon" width={20} height={20} color={PALETTE.primaryText} upArrowColor={PALETTE.loginFooterText} downArrowColor={PALETTE.loginFooterText} />
        </View>
      );
    }
  }

  renderSortArrow(isSelected) {
    const { state = {} } = this.props;
    const { ascending } = state;
    const sortArrowTestId = ascending
      ? 'sort-arrow-ascending'
      : 'sort-arrow-descending';
    let sortArrow = '';

    if (isSelected) {
      sortArrow = ascending ? arrowAscending : arrowDescending;
    }

    if (!sortArrow) {
      return <View style={styles.sortArrow} />;
    }

    return (
      <View style={styles.sortArrow} testID={sortArrowTestId}>
        <Svg>
          <Path d={sortArrow} fill={PALETTE.secondaryText} />
        </Svg>
      </View>
    );
  }

  renderOption(
    {
      label,
      key,
      width,
      displayCurrency,
      isPhone,
      isTablet,
      customStyle,
      optionStyle,
    },
    index
  ) {
    const {
      enabled: isEnabled,
      state = {},
      currency,
      screen,
      messages,
      isPosTransFactory,
      headerStyle,
      iconSortEnabled = false
    } = this.props;
    const { selectedKey, ascending } = state;
    const isSelected = key === selectedKey;
    const firstItemStyles = !index ? styles.itemFirst : {};
    const lastItemStyles = index === this.props.options.length - 1 ? styles.itemLast : {};
    let restItemstyles = customStyle ? styles.customItemStyle : styles.item;
    const customOptionStyle = optionStyle ? optionStyle : {};
    if (key == 'isin' && !customStyle) {
      restItemstyles = styles.customItemCenterStyle;
    }

    const localeLabels = messages[label];
    const labelText =
      displayCurrency && currency
        ? `${localeLabels} (${currency})`
        : localeLabels;
    let quantityText = false;
    /*if(isPosTransFactory){  
       if(labelText === QUANTITY || labelText === STüCKZAHL){
          quantityText = true;
       }
    }*/
    if (labelText === QUANTITY || labelText === STüCKZAHL) {
      quantityText = true;
    }
    const isPhones = isPhone ? isPhone : false;
    const isTablets = isTablet ? isTablet : false;
    const touchableComponent = (
      <div style={{ flex: width ? width : 0 }}>
        <TouchableOpacity
          style={[
            restItemstyles,
            firstItemStyles,
            customOptionStyle,
            lastItemStyles,
          ]}
          onPress={() => this.onOptionPress(key, ascending)}
          key={index}
          disabled={iconSortEnabled ? !iconSortEnabled : !isEnabled}
          disabled={!isEnabled}
          testID={`item${isSelected ? '-selected' : ''}`}
        >
          {quantityText ? (isPosTransFactory ? <Text style={styles.quantityLabel} testID="label">
            {labelText}
          </Text> :
            <Text style={styles.quantityLabelAsset} testID="label">
              {labelText}
            </Text>) :
            <Text style={{ ...styles.label, ...headerStyle }} testID="label">
              {labelText}
            </Text>
          }

          {iconSortEnabled ?
            this.renderSortAsset(isSelected)
            :
            isEnabled && this.renderSortArrow(isSelected)
          }
        </TouchableOpacity>

      </div>
    );
    {
      if (isPhones !== null && isTablets !== null) {
        {
          if (screen.isSmall && isPhones) {
            return touchableComponent;
          }
        }
        {
          if (!screen.isSmall && isTablets) {
            return touchableComponent;
          }
        }
      }
    }
  }

  render() {
    const { options = [], showBorder } = this.props;

    return (
      <View
        style={[styles.container, showBorder && styles.showBorder]}
        testID="table-header"
      >
        {options.map(this.renderOption)}
      </View>
    );
  }
}
